import React from 'react';
import Header from '../../../Header';
import { PrimaryCTA } from '../../../Buttons';

export default function ListingSubmissionReviewalHeader() {
  return (
    <Header colorScheme="warning">
      <div className="flex flex-col items-center justify-center">
        <div className="font-light text-orange-800 text-center">
          This listing is awaiting your review
        </div>

        <div className="flex">
          <div className="mr-1"><PrimaryCTA type="success" data-ng-click="approveListing()">Approve</PrimaryCTA></div>
          <PrimaryCTA type="error" data-ng-click="rejectListing()">Reject</PrimaryCTA>
        </div>
      </div>
    </Header>
  );
}
